import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { STOCK_PHOTOS } from "@/lib/stockPhotos";

const cats = Object.keys(STOCK_PHOTOS);

const StockPhotoPicker = ({ open, onClose, onSelect }) => {
  const [cat, setCat] = useState(cats[0]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="stock-picker">
        <DialogHeader><DialogTitle>Libreria foto</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground -mt-2">Scegli una foto generica; potrai sostituirla con la tua in qualsiasi momento.</p>
        <div className="flex flex-wrap gap-2 my-3">
          {cats.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`stock-cat-${c}`} className={`rounded-full px-3 py-1.5 text-xs font-medium border capitalize ${cat === c ? "bg-[#002FA7] text-white border-[#002FA7]" : "border-border text-muted-foreground hover:border-[#002FA7]"}`}>{c}</button>
          ))}
        </div>
        <div className="grid grid-cols-3 gap-2">
          {STOCK_PHOTOS[cat].map((u, i) => (
            <button key={i} onClick={() => onSelect(u)} data-testid={`stock-img-${cat}-${i}`} className="aspect-square rounded-lg overflow-hidden border border-border hover:ring-2 hover:ring-[#002FA7] transition-shadow">
              <img src={u} alt={cat} className="w-full h-full object-cover" loading="lazy" />
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default StockPhotoPicker;
